import { render, staticRenderFns } from "./adminProfileNew.vue?vue&type=template&id=d936734c&"
import script from "./adminProfileNew.vue?vue&type=script&lang=js&"
export * from "./adminProfileNew.vue?vue&type=script&lang=js&"
import style0 from "./adminProfileNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports